module.exports = __webpack_public_path__ + "static/media/Timer.a40784cd.svg";